import {FC} from "react";
import styled from "@emotion/styled";
import {PureButton} from "components/Common";
import {partial} from "lodash";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	gap: 10px;
	justify-content: center;
	align-items: center;
`;

const ArrowButton = styled(PureButton)`
	color: ${({theme}) => theme.colorPalette.primary};

	svg {
		vertical-align: middle;
	}
`;

const Item = styled(PureButton)`
	width: 12px;
	height: 12px;
	background: #a408a4;

	&.active {
		background: ${({theme}) => theme.colorPalette.primary};
	}
`;

const getClassName = (index: number, activeIndex: number) =>
	index === activeIndex ? "active" : "";

interface IDots {
	length: number;
	index: number;
	changeHandler: (index: number) => void;
}

export const Dots: FC<IDots> = ({index, length, changeHandler}) => {
	return (
		<Wrapper>
			<ArrowButton onClick={partial(changeHandler, index - 1)}>
				<ArrowBackIosIcon />
			</ArrowButton>
			{Array.from({length}).map((_, i) => (
				<Item
					key={i}
					className={getClassName(i, index)}
					onClick={partial(changeHandler, i)}
				/>
			))}
			<ArrowButton onClick={partial(changeHandler, index + 1)}>
				<ArrowForwardIosIcon />
			</ArrowButton>
		</Wrapper>
	);
};
